import useFetch from "v4/hooks/useFetch";
import apiService from "v4/services/api.service";
import {QUOTE_GENERATE} from "v4/data/apiRoutes";
import {useEffect, useState} from "react";
import UserService from "api/user/user";

export default function useTemplatePdf(updateHandler) {
    const customerId = UserService.getCustomerId()
    const [{
        data: dataGenerate,
        isLoading: isLoadingGenerate,
        isError: isErrorGenerate
    }, fetchGenerate] = useFetch()
    const [pdfFile, setPdfFile] = useState(null);

    const generate = ({quoteId, template, showPrices, filename}) => {
        if (!quoteId || !template) return;

        fetchGenerate({
            url: apiService.generateUrl(QUOTE_GENERATE, {id: quoteId}),
            config: {
                method: 'POST',
                body: JSON.stringify({templateId: template, showPrices, customerId, filename})
            }
        })
    }

    useEffect(() => {
        if (
            dataGenerate &&
            !isErrorGenerate &&
            dataGenerate.id
        ) {
            updateHandler(dataGenerate)
            setPdfFile(dataGenerate)
        }

        return () => setPdfFile(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGenerate, isErrorGenerate])

    return ({
        generate,
        isLoadingGenerate,
        pdfFile,
    })
}
